var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hr',{style:(_vm.$vuetify.theme.dark? 'border: 1px dotted #424242;border-radius: 3px;' : 'border: 1px dotted #D0D0D0;border-radius: 3px;')})}
var staticRenderFns = []

export { render, staticRenderFns }